import * as React from 'react';
import { observer } from 'mobx-react';
import { Loading } from 'components/Common/loading';
import { INotificationItemView } from 'components/Notification/notificationItemView';
import { NotificationStore } from 'nomst/Stores/Notification/notification.store';
import { NotificationItem } from 'typings/notificationSummary';
import './notificationView.scss';

export interface INotificationViewProps {
    notificationStore: NotificationStore;
}

@observer
export default class NotificationView extends React.Component<INotificationViewProps> {
    constructor(props: INotificationViewProps) {
        super(props);
        this.handleToggleNotificationMenu = this.handleToggleNotificationMenu.bind(this);
    }

    componentDidMount(): Promise<void> {
        const { notificationStore } = this.props;
        return notificationStore.setLastReadNotifications();
    }

    render(): React.ReactNode {
        return [(
            <div key="notification-wrapper" className="notification-wrapper">
                <div className="notification-view pxl-box">
                    <div className="pxl-padding-large notification-header">
                        <h3>Notifications</h3>
                        <button
                            className="no-btn-style notification-view__close"
                            onClick={this.handleToggleNotificationMenu}
                        >
                            <i className="icon-cancel" />
                        </button>
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        ),
        (
            <button
                key="notification-modal"
                className="pxl-modal notification-modal pxl-link"
                onClick={this.handleToggleNotificationMenu}
            />
        )];
    }

    private handleToggleNotificationMenu(): void {
        this.props.notificationStore.toggleNotificationMenu();
    }

    private renderCategoryName(
        items: NotificationItem[],
        currentItem: NotificationItem,
        index: number): React.ReactNode {
        if (index > 0 && items[index - 1].category === currentItem.category) {
            return null;
        }

        return (
            <h4 key={`category-${index}`}>
                {currentItem.category}
            </h4>
        );
    }

    private renderNotificationItemView(currentItem: NotificationItem, index: number): React.ReactNode {
        const NotificationItemComponent = currentItem.renderedComponent as INotificationItemView;
        return <NotificationItemComponent key={index} item={currentItem} />;
    }

    private renderContent(): React.ReactNode {
        const { notificationStore } = this.props;
        if (notificationStore.isLoading) {
            return (
                <div className="notification-container">
                    <Loading className="small-padding" />
                </div>
            );
        }

        return (
            <div className="notification-container">
                {notificationStore.sortedNotificationItems?.map((currentItem, index, notifications) => [
                    this.renderCategoryName(notifications, currentItem, index),
                    this.renderNotificationItemView(currentItem, index)])}
                <div
                    hidden={notificationStore.hasNotificationItems}
                    className="no-notifications"
                >
                    <i className="icon-thumbs-up" />
                    You are all caught up!
                </div>
            </div>
        );
    }
}